import { apiFetch } from "./apiClient";

export function loginApi(payload) {
    return apiFetch("/api/auth/login", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function recuperarClaveApi(payload) {
    return apiFetch("/api/auth/recuperar-clave", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}